import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="hero">
      <div className="hero-overlay">
        <div className="hero-content">
          <h1 className="hero-title">KAWILA HOSTEL & COFFEE</h1>
          <p className="hero-subtitle">Experimenta la historia en Santa Ana</p>
          <p className="hero-description">
            Una propiedad colonial con arquitectura gótica donde cada detalle cuenta una historia
          </p>
          <div className="hero-features">
            <div className="feature-item">
              <span className="feature-icon">🏛️</span>
              <span>Arquitectura Colonial</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">☕</span>
              <span>Café Excepcional</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🍳</span>
              <span>Desayuno Incluido</span>
            </div>
          </div>
          <button className="hero-btn" onClick={scrollToContact}>
            Reserva Ahora
          </button>
        </div>
      </div>
      <div className="hero-scroll-indicator">
        <span>Descubre más</span>
        <div className="scroll-arrow">↓</div>
      </div>
    </section>
  );
};

export default Hero;
